import React, { forwardRef } from "react";
import { Button, Tooltip, CircularProgress } from "@material-ui/core";

const MuiButton = forwardRef(function MuiButton(
  {
    title,
    image,
    disabled,
    loading,
    innerIcon,
    startIcon,
    tooltip,
    fullwidthOnSm,
    badge,
    ...props
  },
  ref
) {
  return (
    <Tooltip title={tooltip || ""} placement="bottom">
      <Button
        ref={ref}
        disableElevation
        disabled={disabled || loading}
        className={`${props.className ? props.className : ""} ${
          fullwidthOnSm ? "fwsm" : ""
        }`}
        startIcon={loading ? <CircularProgress size={15} /> : startIcon}
        {...props}
      >
        {badge && (
          <div className="button-badge">
            <small>{badge}</small>
          </div>
        )}
        <div className="button-info">
          {innerIcon && !loading && innerIcon}
          {title && <span>{title}</span>}
          {image}
        </div>
      </Button>
    </Tooltip>
  );
});

export default MuiButton;
